import { createSelector } from 'reselect';

const permissions = state => state.authorization.permissions;

export const userPermittedActions = createSelector(permissions, permissions => userId => {
  let actions = [];

  if (permissions[`become_user_id_${userId}`] === true) actions = [...actions, 'login_as'];
  actions = [...actions, 'message'];
  if (permissions[`read_contract_user_id_${userId}`] === true) actions = [...actions, 'contracts'];
  if (permissions[`read_pager_user_id_${userId}`] === true) actions = [...actions, 'pagers'];
  if (permissions[`schedule_user_id_${userId}`] === true) actions = [...actions, 'schedule'];

  return actions;
});

export default { userPermittedActions };
